var render = function render(){var _vm=this,_c=_vm._self._c;return ((_vm.gotId && _vm.showShipmentView))?_c('generic-shipment-view',{attrs:{"my-shipment":this.myShipmentData},on:{"failedLoad":_vm.failedLoad}}):_c('IndexView',{attrs:{"error-message":this.errorMessage,"error-occured":this.errorOccured,"is-loading":this.isLoading},on:{"clicked":_vm.search}})
}
var staticRenderFns = []

export { render, staticRenderFns }